module.exports = __webpack_public_path__ + "img/c3-tit_m.bd7b5f4c.png";